import { Injectable } from '@angular/core';
import { SubmitOrderRequest, ConfirmAndPay, OrderGuestPaymentInfo, UserOrderInfo, Recipe  } from '@core/redux/stores';
import { ManagePaymentRequest } from '@features/account/models';
import { LoggingService } from '@core/services/logging.service';

@Injectable()
export class CheckoutService {

  public paymentMethod: string;
  public cardBrand: string;
  public cardLast4: string;
  public submitRequest: SubmitOrderRequest;
  public confirmAndPay: ConfirmAndPay;
  public orderPaymentInfo: OrderGuestPaymentInfo;
  public selectedCard: ManagePaymentRequest;
  public save_future_payment = false;
  public previousOrder: UserOrderInfo;
  public previousOrderRecipes: Recipe[];

  constructor(private logger: LoggingService) {}

  addPayment(paymentMethod, cardBrand, cardLast4, save_future_payment = false) {
    this.paymentMethod = paymentMethod;
    this.cardBrand = cardBrand;
    this.cardLast4 = cardLast4;
    this.save_future_payment = save_future_payment;
  }

  isIosSafari() {
    // This needs to be revisited.
    // Once Apple Pay is integrated we can make use of built
    // in functions that library provides to determine whether
    // the platform supports Apple Pay or not

    const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    const iOS = /iPhone|iPad/.test(navigator.userAgent);
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1 ? true : false;
    let isMSStream = false;
    if (window.hasOwnProperty('MSStream')) {
      if (window['MSStream']) {
        isMSStream = true;
      } else {
        isMSStream = false;
      }
    }

    const isIOS = iOS && !isMSStream;

    // if (isSafari && isIOS && !isChrome) {
    if (isSafari && !isChrome) {
      // console.log("Safari on iOS!");
      this.logger.log('Safari!');
      return true;
    }

    return false;

  }

}
